import React from 'react';
import Nav2 from '../Navbar2/Nav2';
// import './side.css'
const Sidebar = () => {
    return (
        <>
            <div>

                <Nav2 />
            </div>
        </>
    );
};

export default Sidebar;